<!-- eslint-disable vue/html-closing-bracket-newline -->
<template>
  <v-flex xs12>
    <v-card elevation="15">
      <v-card-title primary-title class="h3">
        Helgdagar
      </v-card-title>       
      <v-card-text>
        <v-form ref="form">
          <v-container>
            <v-row class="align-center">              
              <v-col cols="12"
                     sm="6"
                     md="2">
                <v-select
                  v-model="holiday.descriptionId"
                  :items="holidayList"
                  item-text="description"
                  item-value="id"
                  label="Helgdag"                                    
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="2"
      
              >
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="holiday.startReportDay"
                      label="Starta inrapportering"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"                     
                    />
                  </template>
                  <v-date-picker
                    v-model="holiday.startReportDay"
                    :first-day-of-week="1"
                    locale="sv-SE"
                    @input="menu1 = false"
                  />
                </v-menu>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="2"
      
              >
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="holiday.startForceReportDay"
                      label="Blir tvingande"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="holiday.startForceReportDay"
                    :first-day-of-week="1"
                    locale="sv-SE"
                    @input="menu2 = false"
                  />
                </v-menu>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="2"
      
              >
                <v-menu
                  v-model="menu3"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="holiday.day"
                      label="Leveransdag"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="holiday.day"
                    :first-day-of-week="1"
                    locale="sv-SE"
                    @input="menu3 = false"
                  />
                </v-menu>
              </v-col>
              <v-col  
                cols="2"
                sm="2"
                md="1"
                class="center">
                <v-btn small icon
                       @click.stop="save()"
                >
                  <v-icon>
                    save
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>       
          </v-container>       
        </v-form>        
      </v-card-text>
      <v-card-text>
        <v-card-title>Aktuella Helgdagar</v-card-title>
        <v-simple-table>
          <template>
            <thead>
              <tr>
                <th class="text-left">
                  Beskrivning
                </th>
                <th class="text-left">
                  Starta inrapportering
                </th>
                <th class="text-left">
                  Blir tvingande
                </th>
                <th class="text-left">
                  Leveransdag
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item,idx) in holidays"
                :key="item.id"
                @click="edit(idx)"
              >
                <td>{{ item.description }}</td>
                <td>{{ item.startReportDay|toLocalDate }}</td>
                <td>{{ item.startForceReportDay|toLocalDate }}</td>                
                <td>{{ item.day|toLocalDate }}</td>
                <td>
                  <v-btn small icon
                         @click.stop="completed(item)"
                  >
                    <v-icon color="green">
                      check
                    </v-icon>
                  </v-btn>
                  
                  <v-btn x-small icon class="pl-3"
                         @click.stop="remove(item)"                         
                  >
                    <v-icon color="primary">
                      delete
                    </v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </v-flex>
</template>
<script>
import api from '@/backend/adminapi'
import log from '@/logger'
import _ from 'lodash'

export default {    
  name: 'Holidays',
  data(){return {
    holidayList:[],
    holidays:[],
    loading:false,
    holiday:{
          id:0,
          descriptionId:0,
          startReportDay:'',
          startForceReportDay:'',            
          day:''            
        },
    menu1: false,
    menu2: false,
    menu3: false,
  }},
  mounted() {
    this.loadData()
  },
  methods: {   
    loadData() {
      console.log('Get holiday')
      var self = this
      api
        .adminGetHolidayList()
        .then((resp) => {
          log.debug(resp.data)
          this.loading = false
          this.holidayList = resp.data
        })
       
        .catch((err) => {
          if (
            (err.response && err.response.status === 401) ||
            err.response.status === 403
          ) {
            log.error(err)
            self.loading = false
            self.$router.push({ name: 'root' })
          } else if (err.response && err.response.status === 404) {
            log.error(err)
            self.loading = false
          }
        })
        
        api
        .adminGetHolidays()
        .then((resp) => {
          log.debug(resp.data)
          this.loading = false
          this.holidays = resp.data
        })
       
        .catch((err) => {
          if (
            (err.response && err.response.status === 401) ||
            err.response.status === 403
          ) {
            log.error(err)
            self.loading = false
            self.$router.push({ name: 'root' })
          } else if (err.response && err.response.status === 404) {
            log.error(err)
            self.loading = false
          }
        })
    },
    edit(idx){
      var holiday = this.holidays.at(idx)
      log.debug(holiday)
      this.holiday = Object.assign({}, holiday)
      this.holiday.day = this.$options.filters.toLocalDate(this.holiday.day)
      this.holiday.startReportDay = this.$options.filters.toLocalDate(this.holiday.startReportDay)
      this.holiday.startForceReportDay = this.$options.filters.toLocalDate(this.holiday.startForceReportDay)
    },
    completed(holiday){
      this.loading = true
      api.adminCompleteHoliday(holiday.id)
      .then((resp) => {
          log.debug(resp.data)
          this.loading = false
          this.holidays = _.reject(this.holidays, function(item) {return (item.id === holiday.id)})        
        })       
        .catch((err) => {
          if (
            (err.response && err.response.status === 401) ||
            err.response.status === 403
          ) {
            log.error(err)
            self.loading = false
            self.$router.push({ name: 'root' })
          } else if (err.response && err.response.status === 404) {
            log.error(err)
            self.loading = false
          }
        })
    },
    remove(holiday){
      this.loading = true
      api.adminDeleteHoliday(holiday.id)
      .then((resp) => {
          log.debug(resp.data)
          this.loading = false
          this.holidays = _.reject(this.holidays, function(item) {return (item.id === holiday.id)})        
        })
       
        .catch((err) => {
          if (
            (err.response && err.response.status === 401) ||
            err.response.status === 403
          ) {
            log.error(err)
            self.loading = false
            self.$router.push({ name: 'root' })
          } else if (err.response && err.response.status === 404) {
            log.error(err)
            self.loading = false
          }
        })
    },
    save(){
      // var req = {         
      //   id:this.holiday.id,         
      //   day:this.holiday.day,
      //   startReportDay:this.holiday.startReportDay,
      //   startForceReportDay:this.holiday.startForceReportDay,
      //   descriptionId:this.holiday.descriptionId                  
      // }
      log.debug(this.holiday)
      api.adminAddHoliday(this.holiday)
      .then((resp) => {
          log.debug('Holiday saved:', resp.data)
          this.loadData()
          this.holiday = {
            id:0,
            descriptionId:0,
            startReportDay:'',
            startForceReportDay:'',            
            day:''            
        }
      })
      .catch((error) => {          
          log.debug('Error saving holiday:', error)
      })          
    }
  }
}
</script>

